<template>
	<RouterView />
</template>
